import { render, staticRenderFns } from "./StatisticsPartner.vue?vue&type=template&id=169e78be&"
import script from "./StatisticsPartner.vue?vue&type=script&lang=js&"
export * from "./StatisticsPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports